import { render, staticRenderFns } from "./DashboardWidgetZedScore.vue?vue&type=template&id=29a948ce&"
import script from "./DashboardWidgetZedScore.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetZedScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports